if (!customElements.get('jd-hire-banner')) {
  customElements.define('jd-hire-banner', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const details = this.querySelector('details');
      if (!details) return;
      const key = 'jd-maestro-hire-banner-closed';
      try { if (sessionStorage.getItem(key) === 'true') details.open = false; } catch {}
      details.addEventListener('toggle', () => {
        try { sessionStorage.setItem(key, String(!details.open)); } catch {}
      }, {signal:this.controller.signal});
      this.addEventListener('keydown', event => {
        if (event.key === 'Escape' && details.open) {
          details.open = false;
          details.querySelector('summary').focus();
        }
      }, {signal:this.controller.signal});
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}
